<div class="main-padding">

  <div class="qb-flex-gb sp-bottom-header">
    <div class="order-details-div"  *ngIf="!customerDetailLoading">
      <span class="order-details-subtitle">Name</span>
      <span class="name customer-name-section max-width-500" [matTooltip]="customerDetails['customerName']?customerDetails['customerName']:'----'">{{customerDetails['customerName'] || '----'}}</span>
    </div>
    <div *ngIf="!editMode" (click)="closePopup()" class="material-icons clear margin-left-auto">clear</div>
  </div>

  <div class="tabs" *ngIf="!customerDetailLoading">
    <div class="qb-d-flex">
      <div class="tab-label" (click)="tabChange('profile')"
        [ngClass]="{ active: mainTopic == 'profile' }">
        Profile
      </div>
      <div class="tab-label" (click)="tabChange('loyalty')" *ngIf="validWidgets | widgetConfig: 71"
        [ngClass]="{ active: mainTopic == 'loyalty' }">
        Loyalty
      </div>
      <div class="tab-label" (click)="tabChange('wallet')"  *ngIf="validWidgets | widgetConfig: 53"
        [ngClass]="{ active: mainTopic == 'wallet' }">
        Wallet
      </div>
      <div class="tab-label" (click)="tabChange('wallet2')"  *ngIf="validWidgets | widgetConfig: 99"
        [ngClass]="{ active: mainTopic == 'wallet2' }">
        Wallet
      </div>
      <div class="tab-label" (click)="tabChange('giftcard')" *ngIf="validWidgets | widgetConfig: 63"
        [ngClass]="{ active: mainTopic == 'giftcard' }">
        Gift Cards
      </div>
      <div class="tab-label" (click)="tabChange('sendoffer')"
      *ngIf="( (validWidgets | widgetConfig: 77) || (athorities | checkIfCustomerCare) )" 
        [ngClass]="{ active: mainTopic == 'sendoffer' }">
        Offer
      </div>
      <div class="tab-label" (click)="tabChange('badges')" *ngIf="(validWidgets | widgetConfig: 101)"
        [ngClass]="{ active: mainTopic == 'badges' }">
        Badges
      </div>
      <div class="tab-label" (click)="tabChange('challenges')" *ngIf="(validWidgets | widgetConfig: 103)"
      [ngClass]="{ active: mainTopic == 'challenges' }">
      Challenges
    </div>
    </div>
  </div>


  <div *ngIf="mainTopic === 'profile' && !customerDetailLoading" class="main-tab-content-height main-white-panel">
    <div class="flex-gap-7 height-100" *ngIf="!customerDetailLoading">
      <div class="flex-1 max-height-100 overflow-y-auto">
        <div class="customer-profile-details" *ngIf="!editMode  && !customerDetailLoading">
          <div class="detail-row">
            <div class="average-order-value-div">
              <div class="order-details-icon-div">
                <span class="material-icons-outlined icons-primary order-details-image">
                  mail
                </span>
              </div>
              <div class="order-details-div">
                <span class="order-details-subtitle">{{'CUSTOMER_PAGE.EMAIL_ID' | i18nTranslate}}</span>
                <span class="order-details-info" [matTooltip]="customerDetails['email']?customerDetails['email']:'----'">{{customerDetails['email'] || '----'}}</span>
              </div>
            </div>
            <div class="average-order-value-div">
              <div class="order-details-icon-div">
                <span class="material-icons-outlined icons-primary order-details-image">
                  signal_cellular_alt
                </span>
              </div>
              <div class="order-details-div">
                <span class="order-details-subtitle">{{'CUSTOMER_PAGE.AVERAGE_ORDER_VALUE' | i18nTranslate}}</span>
                <span class="order-details-info">{{ customerDetails['averageOrderValue'] | customCurrency: revCurrency: true
                  }}</span>
              </div>
            </div>
          </div>
          
          <div class="detail-row">
            <div class="average-order-value-div">
              <div class="order-details-icon-div">
                <span class="material-icons-outlined icons-primary order-details-image">
                  call
                </span>
              </div>
              <div class="order-details-div">
                <span class="order-details-subtitle">{{'CUSTOMER_PAGE.PHONE_NUMBER' | i18nTranslate}}</span>
                <span class="order-details-info" [matTooltip]="customerDetails['phone']?customerDetails['phone']:'----'">{{customerDetails['phone'] || '----'}}</span>
              </div>
            </div>
            <div class="average-order-value-div">
              <div class="order-details-icon-div">
                <span class="material-icons-outlined icons-primary order-details-image">
                  shopping_cart
                </span>
              </div>
              <div class="order-details-div">
                <span class="order-details-subtitle">{{'CUSTOMER_PAGE.TOTAL_ORDERS' | i18nTranslate}}</span>
                <span class="order-details-info">{{customerDetails['orderQuantity']}}</span>
              </div>
            </div>
          </div>
          
    
          <div class="detail-row">
            <div class="average-order-value-div">
              <div class="order-details-icon-div">
                <span class="material-icons-outlined icons-primary order-details-image">
                  cake
                </span>
              </div>
              <div class="order-details-div">
                <span class="order-details-subtitle">Birthday</span>
                <span class="order-details-info" [matTooltip]="customerDetails['birthday']?getDateInFormatForDisplay(customerDetails['birthday']):'----'">{{ getDateInFormatForDisplay(customerDetails['birthday']) || '----'}}</span>
              </div>
            </div>
      
            <div class="average-order-value-div">
              <div class="order-details-icon-div">
                <span class="material-icons-outlined icons-primary order-details-image">
                  event
                </span>
              </div>
              <div class="order-details-div">
                <span class="order-details-subtitle">Anniversary</span>
                <span class="order-details-info" [matTooltip]="customerDetails['anniversary']?getDateInFormatForDisplay(customerDetails['anniversary']):'----'">{{ getDateInFormatForDisplay(customerDetails['anniversary']) || '----'}}</span>
              </div>
            </div>  
          </div>
    
          <!-- <div class="detail-row">
          </div> -->
          
    
          <div class="detail-row">
            <div class="average-order-value-div">
              <div class="order-details-icon-div">
                <span class="material-icons-outlined icons-primary order-details-image">
                  attach_money
                </span>
              </div>
              <div class="order-details-div">
                <span class="order-details-subtitle">{{'CUSTOMER_PAGE.TOTAL_REVENUE' | i18nTranslate}}</span>
                <span class="order-details-info">{{ customerDetails['revenue'] | customCurrency: revCurrency: true }}</span>
              </div>
            </div>
            <div class="average-order-value-div">
              <div class="order-details-icon-div">
                <span class="material-icons-outlined icons-primary order-details-image">
                  loupe
                </span>
              </div>
              <div class="order-details-div">
                <span class="order-details-subtitle">{{'CUSTOMER_PAGE.CUSTOMER_SINCE' | i18nTranslate}}</span>
                <span class="order-details-info" [matTooltip]="customerDetails['customerSince']?getDateInFormatForDisplay(customerDetails['customerSince']):'----'">{{ getDateInFormatForDisplay(customerDetails['customerSince']) || '----'}}</span>
              </div>
            </div>
          </div>

          <div class="detail-row">
            <div class="average-order-value-div">
              <div class="order-details-icon-div">
                <span class="material-icons-outlined icons-primary order-details-image">
                  assignment_ind
                </span>
              </div>
              <div class="order-details-div">
                <span class="order-details-subtitle">Customer Id</span>
                <span class="order-details-info" [matTooltip]="customerDetails['customerId']?(customerDetails['customerId']):'----'">{{ (customerDetails['customerId']) || '----'}}</span>
              </div>
            </div> 
          </div>

          <div class="average-order-value-div max-width-none">
            <div class="order-details-icon-div">
              <span class="material-icons-outlined icons-primary order-details-image">
                storefront 
              </span>
            </div>
            <div class="order-details-div">
              <span class="order-details-subtitle">Store</span>
              <div>
                <div *ngIf="customerDetails['stores'].length==0;else storeList" class="order-details-info">
                  ----
                </div>
                <ng-template #storeList>
                  <div class="list-cont">
                    <div *ngFor="let storeName of customerDetails['stores']" class="mini-list-item" [matTooltip]="storeName">
                      {{storeName}}
                    </div>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>

          <div class="average-order-value-div max-width-none">
            <div class="order-details-icon-div">
              <span class="material-icons-outlined icons-primary order-details-image">
                data_saver_off 
              </span>
            </div>
            <div class="order-details-div">
              <span class="order-details-subtitle">Segment</span>
              <div>
                <div *ngIf="customerDetails['segments'].length==0;else segmentList" class="order-details-info">
                  ----
                </div>
                <ng-template #segmentList>
                  <div class="list-cont">
                    <div *ngFor="let segmentName of customerDetails['segments']" class="mini-list-item" [matTooltip]="segmentName">
                      {{segmentName}}
                    </div>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>

          <button class="primary-button ed-button button-hover-effect" (click)="editCustomerDetails()" 
          [disabled]="'ROLE_READ_ONLY' | checkIfViewOnly:'disable'" 
          [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') : ('')"
          [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')" >
            Edit Details
          </button>
        </div>

        <div class="customer-details-edit" *ngIf="editMode  && !customerDetailLoading">
          <div class="edit-header order-details-info">
            Edit Details
          </div>
          <div class="detail-row-3 margin-bottom-20">
            <div class="flex-1">
              <label class="label-style-2">First Name</label><span class="qb-imp-color">*</span>
              <div class="rp-name-inp-container-2 max-width-100">
                  <input class="rp-name-inp" type="text" placeholder="First Name" [(ngModel)]="customerEditableDetails.firstName" (keydown)="resetErrorState()" #inp>
              </div>
              <div class="qb-error-text-3" *ngIf="customerEditableDetailsError.firstNameError">{{customerEditableDetailsError.firstNameError}}</div>
            </div>
            
            <div class="flex-1">
              <label class="label-style-2">Last Name</label>
              <div class="rp-name-inp-container-2 max-width-100">
                  <input class="rp-name-inp" type="text" placeholder="Last Name" [(ngModel)]="customerEditableDetails.lastName" (keydown)="resetErrorState()" #inp1>
              </div>
            </div>
          </div>
          
      
          <!-- <div class="detail-row">
            <div>
              <label class="label-style-2">Email</label><span class="qb-imp-color">*</span>
              <div class="rp-name-inp-container-2 max-width-100">
                  <input class="rp-name-inp" type="text" placeholder="First Name" [(ngModel)]="customerEditableDetails.email" maxlength="50" (keydown)="resetErrorState()" #inp3>
                  <div class="inp-text-left">{{inp3.value.length}}/{{inp3.getAttribute('maxlength')}}</div>
              </div>
            </div>
      
            <div>
              <label class="label-style-2">OR</label>
            </div>
            
            <div class="rp-name-inp-container-2 ph-code-inp">
              <input class="rp-name-inp" type="text" [value]="customerEditableDetails.phoneCode" readonly>
            </div>
      
            <div>
              <label class="label-style-2">Phone</label><span class="qb-imp-color">*</span>
              <div class="rp-name-inp-container-2 phone-inp-size">
                  <input class="rp-name-inp" type="text" placeholder="{{customerEditableDetails.phoneNumberLength}} digits phone number" [(ngModel)]="customerEditableDetails.phone" [maxlength]="customerEditableDetails.phoneNumberLength" (keydown)="numberInputHandler($event,customerEditableDetails.phoneNumberLength)" #inp4>
                  <div class="inp-text-left">{{inp4.value.length}}/{{inp4.getAttribute('maxlength')}}</div>
              </div>
            </div>
          </div>
          <div class="qb-error-text-3" *ngIf="customerEditableDetailsError.emailPhoneError">{{customerEditableDetailsError.emailPhoneError}}</div> -->
      
          <div class="detail-row margin-bottom-20">
            <div>
              <label class="label-style-2">Date Of Birth</label>
              <div class="rp-name-inp-container-2 date-inp-container">
                  <input
                      [(ngModel)] = "customerEditableBirthday"
                      [max]="minDate"
                      class="rp-name-inp cursor-pointer"
                      matInput
                      [matDatepicker]="picker1"
                      placeholder="Choose a date"
                      readonly
                      (click)="picker1.open()"
                  />
                  <mat-datepicker-toggle matSuffix [for]="picker1">
                  </mat-datepicker-toggle>
                  <mat-datepicker #picker1></mat-datepicker>
              </div>
            </div>
        
            <div>
              <label class="label-style-2">Anniversary</label>
              <div class="rp-name-inp-container-2 date-inp-container">
                  <input
                      [(ngModel)] = "customerEditableAnniversary"
                      [max]="minDate"
                      class="rp-name-inp cursor-pointer"
                      matInput
                      [matDatepicker]="picker2"
                      placeholder="Choose a date"
                      readonly
                      (click)="picker2.open()"
                  />
                  <mat-datepicker-toggle matSuffix [for]="picker2">
                  </mat-datepicker-toggle>
                  <mat-datepicker #picker2></mat-datepicker>
              </div>
            </div>
          </div>
      
          <div class="buttons-row">
            <button class="primary-button button-hover-effect" (click)="saveCustomerDetails()">
              Save
            </button><button class="primary-button button-hover-effect" (click)="editMode = false" >
              Cancel
            </button>
          </div>
        </div>
      </div>
      
      <div class="flex-1 sp-mat-tab-group">
        <mat-tab-group animationDuration="0ms" *ngIf="validWidgets | widgetConfig: 70">
          <mat-tab label="Last 10 Orders">
            <div *ngIf="recentOrdersArray.length < 1">
              <div class="no-data">{{'CUSTOMER_PAGE.NO_RECENT_ORDERS' | i18nTranslate}}</div>
            </div>
            <div *ngIf="recentOrdersArray.length >= 1" class="height-100">
              <table class="table table-1">
                <thead>
                  <tr>
                    <th class="qb-w-20">Order Date</th>
                    <th class="qb-w-25">Order Id</th>
                    <th class="qb-w-20 text-align-right">Order Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let order of recentOrdersArray">
                    <td class="qb-w-20">{{order['orderDate']}}<br /> {{order['orderTime']}}</td>
                    <td class="ellipsis-text qb-w-25"><span  [matTooltip]="order['orderId']">{{order['orderId']}}</span></td>
                    <td class="qb-w-20 text-align-right">{{ order['orderValue'] | customCurrency: revCurrency: true }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </mat-tab>
          <mat-tab label="Reviews">
            <div *ngIf="reviewsArray.length < 1">
              <div class="no-data">{{'CUSTOMER_PAGE.NO_REVIEWS' | i18nTranslate}}</div>
            </div>
            <div class="reviews" *ngFor="let review of reviewsArray">
              <div class="review-date">
                <span>{{review['createdAt']}}</span>
              </div>
              <div class="review">
                <div class="review-title">{{review['question']}}</div>
                <div class="review-body">{{review['answer']}}</div>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>

  <div *ngIf="mainTopic === 'loyalty'  && !allCustomersListViewDataLoading" class="main-tab-content-height main-white-panel overflow-auto">
    <div  class="flex-gap-7 padding-bottom-13">
      <div class="customer-profile-details max-width-480 flex-1">
        <div class="average-order-value-div flex-unset">
          <div class="order-details-icon-div">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path  d="M17.9308 7.94922C18.0011 7.99609 18.0363 8.05469 18.0363 8.125C18.0363 8.19531 18.0011 8.25391 17.9308 8.30078L16.5246 8.86328L15.9621 10.2695C15.9152 10.3398 15.8566 10.375 15.7863 10.375C15.716 10.375 15.6574 10.3398 15.6105 10.2695L15.048 8.86328L13.6417 8.30078C13.5714 8.25391 13.5363 8.19531 13.5363 8.125C13.5363 8.05469 13.5714 7.99609 13.6417 7.94922L15.048 7.35156L15.6105 5.98047C15.6574 5.91016 15.716 5.875 15.7863 5.875C15.8566 5.875 15.9152 5.91016 15.9621 5.98047L16.5246 7.35156L17.9308 7.94922ZM12.8331 9.63672C13.1613 9.68359 13.3722 9.87109 13.466 10.1992C13.5831 10.5039 13.5246 10.7734 13.2902 11.0078L10.6183 13.6094L11.2511 17.3008C11.2511 17.3477 11.2511 17.3945 11.2511 17.4414C11.2511 17.6523 11.1691 17.8398 11.005 18.0039C10.8644 18.168 10.6769 18.25 10.4425 18.25C10.3253 18.25 10.2081 18.2148 10.091 18.1445L6.78627 16.4219L3.48158 18.1445C3.3644 18.2148 3.23549 18.25 3.09487 18.25C2.88393 18.25 2.69643 18.168 2.53237 18.0039C2.39174 17.8633 2.32143 17.6758 2.32143 17.4414C2.32143 17.3945 2.32143 17.3477 2.32143 17.3008L2.95424 13.6094L0.282366 11.0078C0.0479911 10.7734 -0.0223214 10.5039 0.0714286 10.1992C0.188616 9.87109 0.411272 9.68359 0.739397 9.63672L4.39565 9.10938L6.04799 5.76953C6.18862 5.46484 6.43471 5.3125 6.78627 5.3125C7.1144 5.3125 7.34877 5.46484 7.4894 5.76953L9.14174 9.10938L12.8331 9.63672ZM9.42299 13.2227L12.0597 10.6562L8.40346 10.1289L6.78627 6.82422L5.16909 10.1289L1.51283 10.6562L4.14955 13.2227L3.51674 16.8438L6.78627 15.1562L10.0206 16.8438L9.42299 13.2227ZM14.9074 3.09766C15.1183 3.21484 15.2238 3.39062 15.2238 3.625C15.2238 3.83594 15.1183 4 14.9074 4.11719L13.2199 4.96094L12.341 6.68359C12.2472 6.89453 12.0831 7 11.8488 7C11.6144 7 11.4503 6.89453 11.3566 6.68359L10.4777 4.96094L8.79018 4.11719C8.57924 4 8.47377 3.83594 8.47377 3.625C8.47377 3.39062 8.57924 3.21484 8.79018 3.09766L10.4777 2.25391L11.3566 0.53125C11.4503 0.34375 11.6144 0.25 11.8488 0.25C12.0831 0.25 12.2472 0.34375 12.341 0.53125L13.2199 2.25391L14.9074 3.09766ZM12.5519 4.04688L13.3956 3.625L12.5519 3.16797C12.4347 3.12109 12.341 3.03906 12.2706 2.92188L11.8488 2.04297L11.4269 2.92188C11.3566 3.03906 11.2628 3.12109 11.1456 3.16797L10.3019 3.625L11.1456 4.04688C11.2628 4.09375 11.3566 4.17578 11.4269 4.29297L11.8488 5.17188L12.2706 4.29297C12.341 4.17578 12.4347 4.09375 12.5519 4.04688Z" fill="#ffffff">
              </path>
            </svg>
          </div>
          <div class="order-details-div">
            <span class="order-details-subtitle">Tier Name</span>
            <span class="order-details-info" [matTooltip]="loyaltyDetails.stats.tierName?loyaltyDetails.stats.tierName:'----'">{{loyaltyDetails.stats.tierName}}</span>
          </div>
          <div class="order-details-div date-box" *ngIf="validWidgets | widgetConfig: 84">
            <span class="order-details-subtitle">Tier Change Date</span>
            <span class="order-details-info" *ngIf="loyaltyDetails.stats.tierChangeDate">{{getDateInFormat(loyaltyDetails.stats.tierChangeDate)}}</span>
            <span class="order-details-info"  *ngIf="!loyaltyDetails.stats.tierChangeDate">----</span>
          </div>
          <div class="order-details-div date-box" *ngIf="validWidgets | widgetConfig: 84">
            <span class="order-details-subtitle">First Order Date</span>
            <span class="order-details-info" *ngIf="loyaltyDetails.stats.firstOrderDate">{{getDateInFormat(loyaltyDetails.stats.firstOrderDate)}}</span>
            <span class="order-details-info" *ngIf="!loyaltyDetails.stats.firstOrderDate">----</span>
          </div>
        </div>
        <div class="loyalty-actions-container" *ngIf="isCustomerSignedUpForLoyalty; else notSignedUpTemplate">
          <div class="rc-popup-footer">
            <div>
              <span class="reward-coin-text">Number of Point(s) </span>
              <span class="reward-coin-text"> to be awarded/deducted : </span>
            </div>
            <div class="rp-name-inp-container">
              <input class="rp-name-inp" type="number" placeholder="Points" [(ngModel)]="coinsToGive"
                (keydown)="numberInputHandler($event,8)" #inp2 maxlength="8" min="0" max="99999999">
              <div class="inp-text-left">{{inp2.getAttribute('maxlength') - inp2.value.length}} {{'SEGMENT_PAGE.CHAEACTER_LEFT'
                | i18nTranslate}}</div>
            </div>
            <!-- <button class="primary-button create-button reward-button" (click)="toggleConfirmation('fromGroupIds')" [disabled]="!coinsToGive || selectedIdsForRewardCoin.length < 1">Award Points</button> -->
          </div>
          <app-wallet-expiry-configuration #profileLoyaltyConfig [loyaltyExpiryConfig]="loyaltyExpiryConfig" [type]="'loyalty'"></app-wallet-expiry-configuration>
          <div class="qb-wallet-note-text">
            * Not applicable for Deduct
          </div>
          <div class="qb-buttons">
            <button class="primary-button qb-create-new-offer-button"
            [disabled]="(('ROLE_READ_ONLY' | checkIfViewOnly:'disable') || !coinsToGive || coinsToGive < 0)" 
            [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') : ('')"
            [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')" 
              (click)="addPointsToCustomer()">
              <mat-icon class="qb-add-icon">add</mat-icon>
              {{'CUSTOMER_PAGE.ADD_POINTS' | i18nTranslate}}
            </button>
            <button [disabled]="(!coinsToGive || coinsToGive < 0) || ('ROLE_READ_ONLY' | checkIfViewOnly:'disable')" class="secondary-button qb-get-customer-offer" (click)="burnCustomerPoints()" 
            [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') : ('')"
            [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')" >
              {{'CUSTOMER_PAGE.DEDUCT_COINS' | i18nTranslate}}
            </button>
          </div>
        </div>
        <ng-template #notSignedUpTemplate>
          <div class="non-loyalty-box">
            <div class="qb-card-balance">Customer has not signed up to your loyalty program yet.</div>
            <button class="primary-button button-hover-effect" (click)="signUpCustomerForLoyalty()" 
            [disabled]="'ROLE_READ_ONLY' | checkIfViewOnly:'disable'" 
            [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') : ('')"
            [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')" >
              Sign Up customer for loyalty
            </button>
          </div>
        </ng-template>
      </div>
      
      <div class="customer-profile-details flex-1">
        <div class="detail-row">
          <div class="qb-card-text-field-div" *ngIf="validWidgets | widgetConfig: 84">
            <div class="qb-card-balance">
              Accumulated Order Value
            </div>
            <div class="qb-card-text">
              {{currencySymbol}} {{getAggregatedValue(loyaltyDetails.stats.accumulatedOrderValue)}}
            </div>
          </div>
          <div class="qb-card-text-field-div max-width-158">
            <div class="qb-card-balance">
              Earned Points
            </div>
            <div class="qb-card-text">
              {{getAggregatedValue(loyaltyDetails.stats.totalEarnedRewardCoins)}}
            </div>
          </div>
          <div class="qb-card-text-field-div">
            <div class="qb-card-balance">
              Expired/Deducted Points
            </div>
            <div class="qb-card-text">
              {{getAggregatedValue(loyaltyDetails.stats.totalBurnedRewardPoints + loyaltyDetails.stats.totalExpiredRewardPoints)}}
            </div>
          </div>
        </div>
        <div class="detail-row">
          <div class="qb-card-text-field-div max-width-158">
            <div class="qb-card-balance">
              Balance Points
            </div>
            <div class="qb-card-text">
              {{getAggregatedValue(loyaltyDetails.stats.availablePoints)}}
            </div> 
          </div>
          <div class="qb-card-text-field-div max-width-158">
            <div class="qb-card-balance">
              Redeemed Points
            </div>
            <div class="qb-card-text">
              {{getAggregatedValue(loyaltyDetails.stats.totalRedeemedRewardPoints)}}
            </div>
          </div>
          <div class="qb-card-text-field-div">
            <div class="qb-card-balance">
              Total Redemption Savings
            </div>
            <div class="qb-card-text">
              {{currencySymbol}} {{getAggregatedValue(loyaltyDetails.stats.totalRedemptionSavings)}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="qb-tr-history">Transaction History</div>
    <div class="qb-table-padding min-height-240">
      <table class="table table-1" *ngIf="loyaltyTransactionDetails.length > 0">
        <thead>
          <tr>
            <th class="qb-w-25">Transaction Date</th>
            <th class="qb-w-20">{{'PROFILE_PAGE.POINTS' | i18nTranslate}}</th>
            <th class="qb-w-20">Offer Count</th>
            <!-- <th>{{'PROFILE_PAGE.REMARK' | i18nTranslate}}</th> -->
            <th class="qb-w-20">Source</th>
            <th class="qb-w-20">Description</th>
            <th class="qb-w-20">Points Expiry Date</th>
            <!-- <th>Status</th> -->
          </tr>
        </thead>
        <tbody *ngIf="loyaltyTransactionDetails.length>0" (scroll)="onScroll($event)">
          <tr *ngFor="let item of loyaltyTransactionDetails">
            <td>{{ item['applicableDateTime'] | date: getDateFormat('dd MMM yyyy')}}<br /> {{item['applicableDateTime'] | date : 'h:mm a'}}</td>
            <td [ngStyle]="{
              color: item.transactionType.toUpperCase() === 'CREDITED'  ? 'green' : 'red'
          }">{{getTransactionType(item.transactionType)}}{{ item.points }}</td>
            <td>{{ item.offerCount }}</td>
            <td>{{ item.earningSource }}</td>
            <td>{{ item.earningSourceDesc }}</td>
            <td>
              <span *ngIf="item.pointsExpiryDate">{{ item['pointsExpiryDate'] | date: getDateFormat('dd MMM yyyy')}}</span>
              <span *ngIf="!item.pointsExpiryDate">---</span>
            </td>
            <!-- <td>{{ item.rule }}</td> -->
            <!-- <td style="color: black">{{ item.status }}</td> -->
          </tr>
        </tbody>
      </table>
  
      <div *ngIf="loyaltyTransactionDetails.length == 0" class="qb-no-data-history">
        {{'PROFILE_PAGE.NO_PAYEMNET_HISTORY' | i18nTranslate}}
      </div>
    </div>
  </div>

  
  <div *ngIf="mainTopic === 'wallet' && !allCustomersListViewDataLoading && customerWalletId !== null" class="main-tab-content-height main-white-panel">
    <div class="offer padding-bottom-13">
      <div class="customer-profile-details">
        <div class="average-order-value-div flex-unset">
          <div class="order-details-icon-div">
            <span class="material-symbols-outlined">
              account_balance_wallet
            </span>            
          </div>
          <div class="order-details-div">
            <span class="order-details-subtitle">Wallet</span>
            <span class="order-details-info">{{balanceAmtInWallet | customCurrency: revCurrency: true}}</span>
          </div>
        </div>

        <div class="loyalty-actions-container">
          <div class="rc-popup-footer">
            <div>
              <span class="reward-coin-text"> Money to be added/deducted : </span>
            </div>
            <div class="rp-name-inp-container">
              <input class="rp-name-inp" type="number" placeholder="Points" [(ngModel)]="coinsToGive"
                (keydown)="numberInputHandler($event,8)" #inp2 maxlength="8" min="0" max="99999999">
              <div class="inp-text-left">{{inp2.getAttribute('maxlength') - inp2.value.length}} {{'SEGMENT_PAGE.CHAEACTER_LEFT'
                | i18nTranslate}}</div>
            </div>
          </div>
          <!-- <button class="primary-button create-button reward-button" (click)="toggleConfirmation('fromGroupIds')" [disabled]="!coinsToGive || selectedIdsForRewardCoin.length < 1">Award Points</button> -->
          <div class="qb-buttons">
            <button class="primary-button" [disabled]="" (click)="addMoneyToWallet()" 
            [disabled]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') || (!coinsToGive || coinsToGive < 0)" 
            [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') : ('')"
            [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')" >
              <mat-icon class="qb-add-icon">add</mat-icon>
              {{'CUSTOMER_PAGE.ADD_MONEY' | i18nTranslate}}
            </button>
            <button [disabled]="" class="primary-button" (click)="deductMoneyFromWallet()" 
            [disabled]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') || (!coinsToGive || coinsToGive < 0)" 
            [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') : ('')"
            [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')" >
              {{'CUSTOMER_PAGE.DEDUCT_MONEY' | i18nTranslate}}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="qb-tr-history">Transaction History</div>
    <div class="qb-table-padding">
      <div *ngIf="walletTransactionDetails.length == 0" class="qb-no-data-history">
        {{'PROFILE_PAGE.NO_PAYEMNET_HISTORY' | i18nTranslate}}
      </div>
      <table class="table table-1" *ngIf="walletTransactionDetails.length > 0">
        <thead>
          <tr>
            <th class="qb-w-25">{{'PROFILE_PAGE.DATE' | i18nTranslate}}</th>
            <th class="qb-w-20">{{'PROFILE_PAGE.AMOUNT' | i18nTranslate}}</th>
            <th>{{'PROFILE_PAGE.REMARK' | i18nTranslate}}</th>
            <!-- <th>Status</th> -->
          </tr>
        </thead>
        <tbody *ngIf="walletTransactionDetails.length>0">
          <tr *ngFor="let item of walletTransactionDetails">
            <td>{{ item['createdTimestamp'] | date: getDateFormat('dd MMM yyyy')}} {{item['createdTimestamp'] | date : 'h:mm a'}}</td>
            <td [ngStyle]="{
              color: item.type.toUpperCase() === 'CREDIT'  ? 'green' : 'red'
          }">{{getTransactionType(item.type)}}{{ item.amount | customCurrency: revCurrency: true}}</td>
            <td>{{ item.comment }}</td>
            <!-- <td style="color: black">{{ item.status }}</td> -->
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div *ngIf="mainTopic === 'wallet2' && !allCustomersListViewDataLoading" class="main-tab-content-height main-white-panel d-flex flex-column overflow-auto">

    <div class="d-flex sp-width sp-height-1">
      <div class="d-flex flex-column col-sp-1">
        <div class="average-order-value-div flex-unset">
          <div class="order-details-icon-div">
            <span class="material-symbols-outlined">
              account_balance_wallet
            </span>            
          </div>
          <div class="order-details-div">
            <span class="order-details-subtitle">Wallet</span>
            <span class="order-details-info">{{balanceAmtInWallet | customCurrency: revCurrency: true}}</span>
          </div>
        </div>
        <div class="topic-wise-balance">
          <div class="title-text-1">Topic wise Balance</div>
          <div class="topics-container">
            <div *ngFor="let topic of topicBalanceData" class="topic-div mb-2">
              <b>{{topic.topicName}}</b> : {{topic.totalTopicBalance | customCurrency: revCurrency: true}}
              <div class="title-text-2">Ledgers:</div>
              <div *ngFor="let ledger of topic.ledgers" class="ledger-div mb-2">
                  <b>{{ledger.ledgerName}}</b> : {{ledger.balance | customCurrency: revCurrency: true}}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="loyalty-actions-container mt-3">
        <div class="rc-popup-footer">
          <div>
            <span class="reward-coin-text"> Money to be added/deducted : </span>
          </div>
          <div class="rp-name-inp-container">
            <input class="rp-name-inp" type="number" placeholder="Points" [(ngModel)]="coinsToGive"
              (keydown)="numberInputHandler($event,8)" #inp22 maxlength="8" min="0" max="99999999">
            <div class="inp-text-left">{{inp22.getAttribute('maxlength') - inp22.value.length}} {{'SEGMENT_PAGE.CHAEACTER_LEFT'
              | i18nTranslate}}</div>
          </div>
        </div>

        <div class="mb-3 mt-3 d-flex">
          <div class="width-50 me-3 flex-grow-1" *ngIf="ledgerList.length>0">
            <label class="main-label-style">Ledger</label><span class="qb-imp-color">*</span>
            <div class="rp-name-inp-container margin-0">
                <mat-select [(ngModel)]="selectedLedgerId">
                    <mat-option *ngFor="let ledger of ledgerList" [value]="ledger.id">{{ledger.ledgerName}}</mat-option>
                </mat-select>
            </div>
          </div>
    
          <div class="width-50" *ngIf="ledgerList.length>0">
            <label class="main-label-style">Transaction Method</label><span class="qb-imp-color">*</span>
            <div class="rp-name-inp-container margin-0">
                <mat-select [(ngModel)]="selectedTransactionMethod">
                    <mat-option *ngFor="let method of transactionMethodList" [value]="method.value">{{method.name}}</mat-option>
                </mat-select>
            </div>
          </div>
        </div>

        <div class="mb-3">
          <label class="main-label-style">Is Refund</label><span class="qb-imp-color">*</span>
          <mat-checkbox class="margin-left-std" color="primary" [(ngModel)]="isRefund"></mat-checkbox>
        </div>

        <div class="mb-3">
          <label class="main-label-style">Transaction Identifier</label><span class="qb-imp-color">*</span>
          <div class="rp-name-inp-container margin-0">
              <input class="rp-name-inp" type="text" placeholder="Enter Identifier" maxlength="50" #inp66 [(ngModel)]="transactionIdentifier" (keydown)="errorFieldList = []">
          </div>
          <div class="input-sub">
              <!-- <div class="error-text" *ngIf="errorFieldList.includes('NAME')">
                  Please enter valid name
              </div> -->
              <div class="inp-text-left">{{inp66.value.length}}/{{ inp66.getAttribute('maxlength')}}</div>
          </div>
        </div>
        <div class="mb-3">
          <label class="main-label-style">Transaction Identifier Meta</label>
          <div class="rp-name-inp-container margin-0">
              <input class="rp-name-inp" type="text" placeholder="Enter Identifier Meta" maxlength="50" #inp66 [(ngModel)]="transactionIdentifierMeta" (keydown)="errorFieldList = []">
          </div>
          <div class="input-sub">
              <!-- <div class="error-text" *ngIf="errorFieldList.includes('NAME')">
                  Please enter valid name
              </div> -->
              <div class="inp-text-left">{{inp66.value.length}}/{{ inp66.getAttribute('maxlength')}}</div>
          </div>
        </div>
        <app-wallet-expiry-configuration #badgeWalletConfig [walletExpiryConfiguration]="walletExpiryConfiguration" [type]="'wallet'"></app-wallet-expiry-configuration>
        <div class="qb-wallet-note-text">
          * Not applicable for Deduct
        </div>


        <div class="qb-buttons">
          <button class="primary-button" (click)="addMoneyToWallet2()"        
          [disabled]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') || (isAddWallet2Disabled())" 
          [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') : (isAddWallet2Disabled()?addWallet2DisabledText:'')"
          [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')">
            <mat-icon class="qb-add-icon">add</mat-icon>
            {{'CUSTOMER_PAGE.ADD_MONEY' | i18nTranslate}}
          </button>
          <button class="primary-button" (click)="deductMoneyFromWallet2()"
          [disabled]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') || (isDeduct2Disabled())" 
          [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') : (isDeduct2Disabled()?deduct2DisabledText:'')"
          [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')">
            {{'CUSTOMER_PAGE.DEDUCT_MONEY' | i18nTranslate}}
          </button>
        </div>
      </div>
    </div>

    <div class="sp-width-2">
      <div class="qb-tr-history-2">Transaction History</div>
      <div class="qb-table-padding-2">
        <div *ngIf="walletTransactionDetails?.length == 0 && !walletTransactionsLoading" class="qb-no-data-history">
          {{'PROFILE_PAGE.NO_PAYEMNET_HISTORY' | i18nTranslate}}
        </div>
        <div *ngIf="walletTransactionsLoading" class="margin-auto">
          <app-qubriux-loading [size]="35" [loadingText]="'Fetching your transactions...'"></app-qubriux-loading>
        </div>
        <table class="table-2" *ngIf="walletTransactionDetails?.length > 0 && !walletTransactionsLoading">
          <thead>
            <tr>
              <th class="w-15">Topic Name</th>
              <th class="w-15">Ledger Name</th>
              <th class="w-15">{{'PROFILE_PAGE.DATE' | i18nTranslate}}</th>
              <th class="w-15">{{'PROFILE_PAGE.AMOUNT' | i18nTranslate}}</th>
              <th class="w-15">Expiry {{'PROFILE_PAGE.DATE' | i18nTranslate}}</th>
              <th class="w-15">{{'PROFILE_PAGE.TRANS_IDENTIFIER' | i18nTranslate}}</th>
              <th class="w-15">{{'PROFILE_PAGE.TRANS_IDENTIFIER_META' | i18nTranslate}}</th>
              <th class="w-25">{{'PROFILE_PAGE.REMARK' | i18nTranslate}}</th>
            </tr>
          </thead>
          <tbody *ngIf="walletTransactionDetails.length>0">
            <tr *ngFor="let item of walletTransactionDetails">
              <td>{{item.topicName || '----'}}</td>
              <td>{{item.ledgerName || '----'}}</td>
              <td>{{ item['createdAt'] | date: getDateFormat('dd MMM yyyy')}} {{item['createdAt'] | date : 'h:mm a'}}</td>
              <td [ngStyle]="{
                color: item.transactionType.toUpperCase() === 'CREDIT'  ? 'green' : 'red'
              }">{{getTransactionType(item.transactionType)}}{{ item.originalAmount | customCurrency: revCurrency: true}} 
              <span *ngIf="item.refund" class="mini-tag">Refund</span> <span *ngIf="item.expired" class="mini-tag">Expired</span></td>
              <td>{{ item['expiryDate'] | date: getDateFormat('dd MMM yyyy')}} {{item['expiryDate'] | date : 'h:mm a'}}</td>
              <td>{{item.transactionIdentifier || '----'}}</td>
              <td>{{item.transactionIdentifierMeta || '----'}}</td>
              <td>{{ item.comments }}</td>
            </tr>
          </tbody>
        </table>
        <div class="lv-options-21" *ngIf="walletTransactionDetails?.length > 0 && !walletTransactionsLoading">
          <mat-paginator
          #paginator 
            [pageIndex]="walletPagginationData.pageIndex"
            [length]="walletPagginationData.total"
            [pageSize]="walletPagginationData.pageSize"
            [pageSizeOptions]="[5, 10, 25]"
            (page)="refreshPaginatedData($event)"
          >
          </mat-paginator>
        </div>
      </div>
    </div>

  </div>

  <div class="activity-spinner-container height-50" *ngIf="mainTopic === 'wallet' && !allCustomersListViewDataLoading && customerWalletId == null">
    Wallet Details Not Found
  </div>
  
  <!-- Gift card functionality -->
  
  <div *ngIf="mainTopic === 'giftcard' && !allCustomersListViewDataLoading && giftcardDetails?.length>0" class="main-tab-content-height main-white-panel">
    <div class="customer-profile-details">
      <div class="average-order-value-div flex-unset">
        <div class="order-details-icon-div">
          <span class="material-symbols-outlined">
            signal_cellular_alt
          </span>            
        </div>
        <div class="order-details-div">
          <span class="order-details-subtitle">Total Cards Received</span>
          <span class="order-details-info">{{ getTotalAmounts().totalCardsReceived }}</span>
        </div>
      </div>
      <div class="average-order-value-div flex-unset">
        <div class="order-details-icon-div">
          <span class="material-symbols-outlined">
            attach_money
          </span>            
        </div>
        <div class="order-details-div">
          <span class="order-details-subtitle">Total Amount Redeemed</span>
          <span class="order-details-info">{{ getTotalAmounts().totalAmountRedeemed | customCurrency: revCurrency: true }}</span>
        </div>
      </div>
    </div>
      <div class="giftcard">

  
        <div *ngFor="let card of giftcardDetails" class="each-card-details" [ngClass]="{'active': card.isActive}" (click)="toggleActive(card)">
          <div class="before-expansion">
            <div class="average-order-value-div flex-unset">
              <div class="order-details-icon-div">
                <span class="material-symbols-outlined">
                  redeem
                </span>            
              </div>
              <div class="order-details-div">
                <span class="order-details-subtitle">Received from {{card.senderName}}</span>
                <span class="order-details-info">Issue date : {{card.issueDate | date: getDateFormat('dd MMM yyyy')}}</span>
                <span [ngClass]="getStatusColorClass(card.status)">{{ card.status }}</span>
              </div>
            </div>
            <!-- <div class="left">
              <div class="icon">
                <span class="material-symbols-outlined">
                  redeem
                  </span>
              </div>
              <div class="main-details">
                <div class="recieved-message">
                  <p>Received from {{card.senderName}}</p>
                </div>
                <div class="date_status">
                  <p style="margin: 0;">Issue date : {{card.issueDate | date: getDateFormat('dd MMM yyyy')}}</p>
                  <p [ngClass]="getStatusColorClass(card.status)">
                    {{ card.status }}
                  </p>
                </div>
                
                
              </div>
            </div> -->
           
            <div class="right">
              <div class="dropdown-icon" [ngClass]="{'rotated': card.isActive}">
                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"/><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"/></svg>
              </div>
            </div>
          </div>
          <div class="after-expansion">
            <div class="detail-row">
              <div class="order-details-div">
                <span class="order-details-subtitle">Gift id</span>
                <span class="order-details-info">{{card.giftCardId}}</span>
              </div>
              <div class="order-details-div">
                <span class="order-details-subtitle">Amount</span>
                <span class="order-details-info">{{card.amount| customCurrency: revCurrency: true}}</span>
              </div>
            </div>
            <div class="detail-row">
              <div class="order-details-div">
                <span class="order-details-subtitle">Action date</span>
                <span class="order-details-info">{{card.actionDate| date: getDateFormat('dd MMM yyyy')}}</span>
              </div>
              <div class="order-details-div">
                <span class="order-details-subtitle">Expiration date</span>
                <span class="order-details-info">{{card.expirationDate| date: getDateFormat('dd MMM yyyy')}}</span>
              </div>
            </div>
            <div class="detail-row">
              <div class="order-details-div">
                <span class="order-details-subtitle">Sender Name</span>
                <span class="order-details-info">{{card.senderName}}</span>
              </div>
              <div class="order-details-div">
                <span class="order-details-subtitle">Sender Message</span>
                <span class="order-details-info">{{card.senderMessage}}</span>
              </div>
            </div>           
          </div>
        </div>
      </div>
    </div>
  
  <div class="activity-spinner-container height-50" *ngIf="mainTopic === 'giftcard' && !allCustomersListViewDataLoading && (!giftcardDetails || giftcardDetails.length == 0)">
    Gift card details Not Found
  </div>
  
  <div class="send-offer" *ngIf="mainTopic === 'sendoffer' && !allCustomersListViewDataLoading" class="main-tab-content-height main-white-panel">
  
    <div class="offer padding-bottom-13">
      <div class="customer-profile-details">
        <div class="average-order-value-div flex-unset">
          <div class="order-details-icon-div">
            <svg width="23" height="19" viewBox="0 0 23 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22.2578 10.5859L15.0859 17.7578C14.7578 18.0859 14.3594 18.25 13.8906 18.25C13.4219 18.25 13.0234 18.0859 12.6953 17.7578L12.625 17.6875L13.4336 16.9141L13.5039 16.9492C13.7617 17.2305 14.0195 17.2305 14.2773 16.9492L21.4492 9.77734C21.7305 9.51953 21.7305 9.26172 21.4492 9.00391L13.9961 1.55078C13.9023 1.43359 13.7734 1.375 13.6094 1.375H12.9414L11.8164 0.25H13.6094C14.0781 0.25 14.4766 0.414062 14.8047 0.742188L22.2578 8.19531C22.5859 8.52344 22.75 8.92188 22.75 9.39062C22.75 9.85938 22.5859 10.2578 22.2578 10.5859ZM9.10938 1.375H1.9375C1.77344 1.375 1.63281 1.43359 1.51562 1.55078C1.42188 1.64453 1.375 1.77344 1.375 1.9375V9.10938C1.375 9.27344 1.43359 9.40234 1.55078 9.49609L9.00391 16.9492C9.26172 17.2305 9.51953 17.2305 9.77734 16.9492L16.9492 9.77734C17.2305 9.51953 17.2305 9.26172 16.9492 9.00391L9.49609 1.55078C9.40234 1.43359 9.27344 1.375 9.10938 1.375ZM9.10938 0.25C9.57812 0.25 9.97656 0.414062 10.3047 0.742188L17.7578 8.19531C18.0859 8.52344 18.25 8.92188 18.25 9.39062C18.25 9.85938 18.0859 10.2578 17.7578 10.5859L10.5859 17.7578C10.2578 18.0859 9.85938 18.25 9.39062 18.25C8.92188 18.25 8.52344 18.0859 8.19531 17.7578L0.742188 10.3047C0.414062 9.97656 0.25 9.57812 0.25 9.10938V1.9375C0.25 1.46875 0.414062 1.07031 0.742188 0.742188C1.07031 0.414062 1.46875 0.25 1.9375 0.25H9.10938ZM5.80469 4.82031C5.66406 4.67969 5.5 4.60938 5.3125 4.60938C5.125 4.60938 4.96094 4.67969 4.82031 4.82031C4.67969 4.96094 4.60938 5.125 4.60938 5.3125C4.60938 5.5 4.67969 5.66406 4.82031 5.80469C4.96094 5.94531 5.125 6.01562 5.3125 6.01562C5.5 6.01562 5.66406 5.94531 5.80469 5.80469C5.94531 5.66406 6.01562 5.5 6.01562 5.3125C6.01562 5.125 5.94531 4.96094 5.80469 4.82031ZM4.11719 4.11719C4.44531 3.78906 4.84375 3.625 5.3125 3.625C5.78125 3.625 6.17969 3.78906 6.50781 4.11719C6.83594 4.44531 7 4.84375 7 5.3125C7 5.78125 6.83594 6.17969 6.50781 6.50781C6.17969 6.83594 5.78125 7 5.3125 7C4.84375 7 4.44531 6.83594 4.11719 6.50781C3.78906 6.17969 3.625 5.78125 3.625 5.3125C3.625 4.84375 3.78906 4.44531 4.11719 4.11719Z" fill="#ffffff"/>
            </svg>            
          </div>
          <div class="order-details-div">
            <span class="order-details-subtitle">Select Offer</span>
            <div class="order-details-info mat-select-report-filter">
              <mat-select placeholder="Offer name" [(ngModel)]="selectedOffer" (closed)="resetFilter()">
                <div class="qb-rectangle">
                    <div class="qb-rect">
                        <mat-icon class="qb-icon" matPrefix>search</mat-icon>
                        <input class="qb-no-border-input" type="text" [(ngModel)]="filter.label"
                            (keydown)="$event.stopPropagation()" placeholder=" Search by name " />
                    </div>
                </div>
                <mat-option *ngFor="let val of offerList | labelPipe: filter.label:'offerName'"
                    [value]="val.id.toString()" selected>
                    {{val.offerName |
                    i18nDynamicTranslate: 'POS_PAGE'}}
                </mat-option>
                <mat-option *ngIf="(offerList | labelPipe: filter.label:'offerName').length === 0" [disabled]="true">
                  No data available
                </mat-option>
              </mat-select>
            </div>
          </div>
        </div>
        <div class="buttons-row">
          <button class="primary-button" (click)="openViewOfferSummary()" [disabled]="!selectedOffer"  [ngClass]="{'disabled-btn': !selectedOffer}"  matTooltip="Select an offer to view."
            [matTooltipDisabled]="!!selectedOffer"> {{'PROFILE_PAGE.OFFER_DETAILS' | i18nTranslate}} </button>
          <button class="primary-button" (click)="sendOffer()" [ngClass]="{'disabled-btn': !selectedOffer}"  
          [disabled]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') || (!selectedOffer)" 
          [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') : ('Select an offer to activate.')"
          [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')" 
            [matTooltipDisabled]="!!selectedOffer && !('ROLE_READ_ONLY' | checkIfViewOnly:'disable')">Activate Offer 
          </button>  
        </div>
      </div>
    </div>
    
    <div class="qb-tr-history">Transaction History</div>
    <div class="qb-table-padding-offer" >
      <div *ngIf="offerTransactionDetails.length == 0" class="qb-no-data-history">
        {{'PROFILE_PAGE.NO_OFFER_HISTORY' | i18nTranslate}}
      </div>
      <table class="table table-1" *ngIf="offerTransactionDetails.length > 0">
        <thead>
          <tr>
            <th class="qb-w-25">{{'PROFILE_PAGE.DATE' | i18nTranslate}}</th>
            <th class="qb-w-20">{{'PROFILE_PAGE.OFFER_CODE' | i18nTranslate}}</th>
            <th class="qb-w-20">{{'PROFILE_PAGE.OFFER_TYPE' | i18nTranslate}}</th>
            <th>{{'PROFILE_PAGE.REMARK' | i18nTranslate}}</th>
            <!-- <th>Status</th> -->
          </tr>
        </thead>
        <tbody *ngIf="offerTransactionDetails.length>0" (scroll)="onScroll($event)">
          <tr *ngFor="let item of offerTransactionDetails">
            <td>{{ item.transactionDate | date: getDateFormat('MMM dd yyyy') }}
              <br>
               {{item['transactionDate'] | date : 'h:mm a'}}</td>
            <td>{{ item?.offerCode }}</td>
            <td [ngStyle]="{
              color: item?.type?.toUpperCase() === 'AWARDED' ? 'green' : 'red'
          }">{{ item.type ? item.type : '' }}</td>
            <td>{{ item.remark }}</td>
            <!-- <td style="color: black">{{ item.status }}</td> -->
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  
  <div class="activity-spinner-container height-50" *ngIf="mainTopic === 'sendoffer' && !allCustomersListViewDataLoading && !offerList.length">
    No offers found
  </div>


  <div class="main-tab-content-height main-white-panel" *ngIf="mainTopic == 'badges' && !customerDetailLoading">
    <div *ngIf="badgeList.length == 0" class="qb-no-data-history">
      No Badge present in account
    </div>
    <div *ngIf="badgeList.length > 0" class="badge-assign">
      <div class="main-label-style">Select Badge to assign</div>
      <mat-select placeholder="Select Badge" [(ngModel)]="selectedBadge" (closed)="badgeSearch = ''" class="badge-select">
        <div class="qb-rectangle" *ngIf="badgeList.length > 5">
            <div class="qb-rect">
                <mat-icon class="qb-icon" matPrefix>search</mat-icon>
                <input class="qb-no-border-input" type="text" [(ngModel)]="badgeSearch"
                    (keydown)="$event.stopPropagation()" placeholder=" Search by name"/>
            </div>
        </div>
        <mat-option *ngFor="let badge of badgeList | labelPipe: badgeSearch:'name'"
            [value]="badge.id" selected>
            {{ badge.name}}
        </mat-option>
        <mat-option *ngIf="(badgeList | labelPipe: badgeSearch:'name').length === 0" [disabled]="true">
          No data available
        </mat-option>
      </mat-select>
      <div class="buttons-row">
        <!-- TODO PREVIEW -->
        <!-- <button class="primary-button" (click)="openViewOfferSummary()" [disabled]="!selectedOffer"  [ngClass]="{'disabled-btn': !selectedOffer}"  matTooltip="Select an offer to view."
          [matTooltipDisabled]="!!selectedOffer"> {{'PROFILE_PAGE.OFFER_DETAILS' | i18nTranslate}} </button> -->
        <button class="primary-button margin-top-std" (click)="assignBadge()" [ngClass]="{'disabled-btn': (!assignBadge) || ('ROLE_READ_ONLY' | checkIfViewOnly:'disable')}" 
        [disabled]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') || (!selectedBadge)"  
        [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') : ('Select an badge to assign.')"
        [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')" 
          [matTooltipDisabled]="!!selectedBadge && !('ROLE_READ_ONLY' | checkIfViewOnly:'disable')">Assign badge 
        </button>  
      </div>
    </div>
    <div class="qb-tr-history">Customer Badges</div>
    <div class="qb-table-padding">
      <table class="table table-1" *ngIf="customerBadgeList.length > 0">
        <thead>
          <tr>
            <!-- <th class="qb-w-25">Badge</th> -->
            <th class="qb-w-25">Badge Name</th>
            <th class="qb-w-25">Awarded Date</th>
            <th class="qb-w-25">Awarded Reason</th>
            <!-- <th class="qb-w-25">Action</th> -->
          </tr>
        </thead>
        <tbody *ngIf="customerBadgeList.length>0" (scroll)="onScroll($event)">
          <tr *ngFor="let badge of customerBadgeList">
            <!-- <td><img [src]="badge.badgeImageUrl" alt="No badge Image" class="mini-img"/></td> -->
            <td>{{badge.name}}</td>
            <td>{{ badge['awardedAt'] }}</td>
            <td>{{badge.awardedReason}}</td>
            <!-- <td>actions here</td> -->
          </tr>
        </tbody>
      </table>
  
      <div *ngIf="customerBadgeList.length == 0" class="qb-no-data-history">
        No badges
      </div>
    </div>
  </div>
  

  <div class="main-tab-content-height main-white-panel" *ngIf="mainTopic == 'challenges' && !customerDetailLoading">
    <div *ngIf="challengeList.length == 0" class="qb-no-data-history">
      No Challenge present in account
    </div>
    <div *ngIf="challengeList.length > 0" class="badge-assign">
      <div class="main-label-style">Select Challenge to activate</div>
      <mat-select placeholder="Select Challenge" [(ngModel)]="selectedChallenge" (closed)="challengeSearch = ''" class="badge-select">
        <div class="qb-rectangle" *ngIf="challengeList.length > 5">
            <div class="qb-rect">
                <mat-icon class="qb-icon" matPrefix>search</mat-icon>
                <input class="qb-no-border-input" type="text" [(ngModel)]="challengeSearch"
                    (keydown)="$event.stopPropagation()" placeholder=" Search by name"/>
            </div>
        </div>
        <mat-option *ngFor="let challenge of challengeList | labelPipe: challengeSearch:'name'"
            [value]="challenge.id" selected>
            {{ challenge.name}}
        </mat-option>
        <mat-option *ngIf="(challengeList | labelPipe: challengeSearch:'name').length === 0" [disabled]="true">
          No data available
        </mat-option>
      </mat-select>
      <div class="buttons-row">
        <button class="primary-button margin-top-std" (click)="assignChallenge()" [ngClass]="{'disabled-btn': !assignChallenge}" 
        [disabled]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') || (!selectedChallenge)" 
        [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') : ('Select an challenge to activate.')"
        [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')" 
          [matTooltipDisabled]="selectedChallenge && !('ROLE_READ_ONLY' | checkIfViewOnly:'disable')">Activate challenge 
        </button>  
      </div>
    </div>
    <div class="qb-tr-history">Customer Challenge : {{challengesCount}}</div>
    <div class="qb-table-padding">
      <table class="table table-1" *ngIf="customerChallengeList.length > 0 && !challengeLoading">
        <thead>
          <tr>
            <th class="qb-w-25">Challenge Name</th>
            <th class="qb-w-25">Joining Date</th>
            <th class="qb-w-25">Status</th>
            <th class="qb-w-25">Remark</th>
          </tr>
        </thead>
        <tbody *ngIf="customerChallengeList.length>0" (scroll)="onScroll($event)">
          <tr *ngFor="let challenge of customerChallengeList">
            <td>{{ challenge?.challenge?.challengeName }}</td>
            <td>{{ (challenge['joiningDate'] | date: getDateFormat('dd MMM yyyy')) || "-"}}</td>
            <td [ngStyle]="{
              color: (challenge?.challenge?.status.toUpperCase() === 'ACTIVE' && challenge['joiningDate']) ? 'green' : 
                    (challenge?.challenge?.status.toUpperCase() === 'ACTIVE' && !challenge['joiningDate']) ? 'black' :
                     challenge?.challenge?.status.toUpperCase() === 'COMPLETED' ? 'blue' : 'red'
          }">{{ getChallenegStatus(challenge?.challenge['status'], challenge['joiningDate']) }}</td>
            <td>{{challenge?.awardedReason || "-"}}</td>
          </tr>
        </tbody>
      </table>
  
      <div *ngIf="customerChallengeList.length == 0 && !challengeLoading" class="qb-no-data-history">
        No Challenge Found
      </div>
      <div *ngIf="challengeLoading" class="margin-auto">
        <app-qubriux-loading [size]="35" [loadingText]="'Fetching customer challenges...'"></app-qubriux-loading>
      </div>
    </div>
  </div>


  <div class="activity-spinner-container height-50" *ngIf="allCustomersListViewDataLoading || customerDetailLoading">
    <app-qubriux-loading  [size]="35" [loadingText]="'Fetching details...'"></app-qubriux-loading>
  </div>
</div>
